module.exports = __webpack_public_path__ + "static/reactjs-6b7aa303981cf97b40b15219097c95a8.jpg";